export const parseRGBString = (color: string) => {
  const rgbaRegex = /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d*\.?\d+))?\s*\)/i
  const match = color.match(rgbaRegex)

  if (match) {
    const r = parseInt(match[1], 10)
    const g = parseInt(match[2], 10)
    const b = parseInt(match[3], 10)
    const a = match[4] ? parseFloat(match[4]) : 1
    return { r, g, b, a }
  }

  return null
}
